module.exports = __webpack_public_path__ + "assets/TeamParrotsHappy.7ee7d65e.svg";